import { SVGProps, Ref, forwardRef } from 'react';

export const LineArrowRightOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M11.672 11.829 15.5 8l-3.828-3.828-.99.99L12.82 7.3H5.843v1.4h6.977l-2.138 2.139z"
                        fill="currentColor"
                    />
                    <path
                        d="M.5 8c0 6.563.938 7.5 7.5 7.5v-1.4c-1.63 0-2.808-.06-3.681-.225-.86-.162-1.287-.4-1.54-.654-.253-.253-.492-.68-.654-1.54C1.96 10.808 1.9 9.63 1.9 8s.06-2.808.225-3.681c.162-.86.4-1.287.654-1.54.253-.253.68-.492 1.54-.654C5.192 1.96 6.37 1.9 8 1.9V.5C1.438.5.5 1.438.5 8"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
LineArrowRightOutlinedSize16Glyph.displayName = 'LineArrowRightOutlinedSize16Glyph';
